import {Injectable} from '@angular/core';
import {GetNewsService} from "./get-news-service";

/*
 Generated class for the KeywordsService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class KeywordsService {
  public keywords = [];

  constructor(public getNewsService: GetNewsService) {
    // console.log('Hello KeywordsService Provider');
  }

  getKeywords() {
    return this.getNewsService.getKeywords();

  }

  // getKeyword(id) {
  //   return this.getNewsService.getKeywords
  //
  // }

  createKeyword(keyword) {
    return this.getNewsService.addKeywords(keyword);

  }

  updateKeyword(keyword) {
    return this.getNewsService.editKeyword(keyword.posiz, keyword)

  }

  deleteKeyword(id) {
    return this.getNewsService.deleteKeyword(id);
  }

  saveKeywords() {
    return this.getNewsService.sendKeywords();
  }

  getAgencyEnablings() {
    return this.getNewsService.getAgencyEnablings();
  }

  saveAgencyEnablings(data) {
    return this.getNewsService.saveAgencyEnablings(data);
  }
}



// WEBPACK FOOTER //
// ./src/providers/keywords-service.ts